import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@qr/ui/tokens.css';
import './index.css';
import { App } from './App.js';

const container = document.getElementById('root');
if (!container) throw new Error('No se encontro el contenedor #root.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
